import Api from "../Api"



const getByIdProfissional = async (idProfissional) => {

    try {
        const { data } = await Api.get('/profissionais/' + idProfissional + '/agendaConfig')
        if (data) {
            return data;
        }
    } catch (error) {
      //  console.log(error)
    }

}
const store = async (idProfissional, dataForm) => {


    try {
        const { data } = await Api.post('/profissionais/' + idProfissional + '/agendaConfig', dataForm)

////console.log(data)
        return data
    } catch (error) {
      //  console.log(error)
        return error
    }

}

export const ProfissionaisConfigService = {
    store,
    getByIdProfissional
}